import { render, staticRenderFns } from "./DlgAdNew.vue?vue&type=template&id=0eac7a50&scoped=true&"
import script from "./DlgAdNew.vue?vue&type=script&lang=ts&"
export * from "./DlgAdNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eac7a50",
  null
  
)

export default component.exports